// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react:true*/
import React, {useContext, useState, useEffect, Fragment} from 'react';
import styles from './faq.module.less';
import {Editor} from '../../../shared/editor/editor';
import {use_element_size} from '../lib/screen_util';
import {On_scroll_animation} from '../shared/on_scroll_animation';
import {App_context} from 'hola_app_context';
import {Faq_question} from '../products/faq_question';
import {Button} from '../lib/button';
import cn from 'classnames';
import {Settings_context} from '../settings_ctx';

interface i_faqs {
    question: string;
    answer: string;
}
interface i_faq {
        title: string;
        faqs?: i_faqs[];
}

interface i_faq_props_editor {
        value: i_faq;
        on_change: (new_value: i_faq)=>void;
        on_cancel: ()=>void;
}

export const Faq = (props: i_faq)=>{
        const {is_client} = useContext(App_context);
        const {theme} = useContext(Settings_context);
        const {title, faqs} = props;
        const [w, h] = use_element_size(is_client && {
            xs: [240, 200],
            lg: [220, 160],
            xl: [440, 320],
            all: [440, 320],
    });
    const faq_schema = {
        '@context': 'https://schema.org',
        'type': 'FAQPage',
        'mainEntity': Array.isArray(faqs) ? faqs.map(faq=>({
            '@type': 'Question',
            'name': faq.question,
            'acceptedAnswer': {
                '@type': 'Answer',
                'text': faq.answer
            }
        })) : []
    };
    const w_value = Number((w||'0px')?.split('px')[0]);
    const h_value = Number((h||'0px')?.split('px')[0]);
        return <div className={styles.faq}>
      <div className={styles.faq_content}>
        <div className={styles.faq_column}>
          <p className={cn(theme.H4, theme.color_n700)}>{title}</p>
          {faqs.map((f, i)=>
            <Faq_question key={i} quest={f.question}
              cls={{title: styles.question_wrapper}} ans={
                <div dangerouslySetInnerHTML={{__html: f.answer}}></div>}/>)}
        </div>
          <div className={styles.faq_smiles}>
            <On_scroll_animation key={'faq_lottie'}
              src={`animation/support_product.json`} size={[w_value, h_value]}
              animation={[{frames: {from: 50, to: 75}, direction: 1,
                loop: false}]}
              cls={styles.faq_lottie} scroll_to_pos={0.05}/>
          </div>
          <script type="application/ld+json"
            dangerouslySetInnerHTML={{__html: JSON.stringify(faq_schema)}}/>
      </div>
    </div>;
};

export const Faq_editor = (props: i_faq_props_editor)=>{
    const [state, set_state] = useState<i_faq>(()=>({
        title: props.value?.title ?? '',
        faqs: props.value?.faqs ?? [],
    }));
    const faqs = state.faqs || [];
    useEffect(()=>{
        set_state(c=>({...c, ...props.value}));
    }, [props.value]);
    return <Editor
      value={state}
      editors={[{key: 'title', label: 'Title', type: 'textarea'}]}
      on_change={v=>set_state(v)}
      on_save={()=>props.on_change(state)}
      on_cancel={props.on_cancel}>
      <h4>FAQs: </h4>
      {faqs.map((li, i)=>
        <Fragment key={i}>
          <Editor
            title={li.question || `unknown`}
            key={i}
            value={li}
            editors={[
              {key: 'question', label: 'Question', type: 'textarea'},
              {key: 'answer', label: 'Answer', type: 'textarea'}
            ]}
            on_change={v=>{
              const items_new = [...faqs];
              items_new[i] = v;
              set_state({...state, faqs: items_new});
            }}>
          </Editor>
          <Button caption={'Delete feature'} size={'xs'}
            on_click={()=>{
              set_state({...state, faqs: faqs
                .filter((_, index)=>index!==i)});
            }}/>
        </Fragment>
      )}
      <Button caption={'Add Question'} size={'xs'}
        on_click={()=>{
          set_state({...state, faqs: [...faqs, {
            question: '',
            answer: '',
          }]});
        }}/>
    </Editor>;
};
